import {
    Box,
    Divider,
    // Fade,
    IconButton,
    // Menu,
    // MenuItem,
    Stack,
    Typography,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
// import useResponsive from "../../hooks/useResponsive";
// import truncateString from "../../utils/trancate";
import SearchIcon from '@mui/icons-material/Search';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import HeadsetMicIcon from '@mui/icons-material/HeadsetMic';

const Header = ({ handleOpenSearch, handleOpenQueue }) => {
    const theme = useTheme();
    // const dispatch = useDispatch();
    // const isMobile = useResponsive("between", "md", "xs", "sm");
    // const isDesktop = useResponsive("up", "md");

    return (
        <>
            <Box
                p={2}
                width={"100%"}
                sx={{
                    backgroundColor:
                        theme.palette.mode === "light"
                            ? "#F8FAFF"
                            : theme.palette.background,
                    boxShadow: "0px 0px 2px rgba(0, 0, 0, 0.25)",
                }}
            >
                <Stack
                    // alignItems={"center"}
                    direction={"row"}
                    sx={{ width: "100%", height: "100%" }}
                    justifyContent="end"
                >
                    {/* Back button and Header*/}
                    <Stack direction={"row"} spacing={1}>

                        {/* Back button
                        <Stack direction={"row"} spacing={2}>
                            <IconButton
                                onClick={handleBack}
                            >
                                <ArrowBackIosIcon /><Typography>Back</Typography>
                            </IconButton>
                            <Divider orientation="vertical" flexItem />
                        </Stack> */}

                        {/* Header */}
                        <Stack
                            // onClick={() => {
                            //     dispatch(ToggleSidebar());
                            // }}
                            spacing={1}
                            direction="row"
                        >
                            {/* <AppealAvatar type={appeal.source_type} isOpen={appeal.is_open}/> */}
                            {/* <Stack spacing={0.1}>
                                <Typography variant="subtitle2">{truncateString("Search", 50)}</Typography>
                                <Typography variant="caption">{name()}</Typography>   
                            </Stack> */}
                        </Stack>
                        <Stack direction={"row"} spacing={2}>
                            <IconButton onClick={handleOpenQueue}>
                                <HeadsetMicIcon />
                            </IconButton>
                            <IconButton onClick={handleOpenSearch}>
                                <SearchIcon />
                            </IconButton>
                            <IconButton>
                                <AddCircleOutlineIcon />
                            </IconButton>
                        </Stack>
                    </Stack>
                </Stack>
            </Box>
        </>
    );
};

export default Header;